export const APP_LOADING_START = "APP_LOADING_START";
export const APP_LOADING_FINISH = "APP_LOADING_FINISH";
export const loadingAppStart = key => ({ type: APP_LOADING_START, key });
export const loadingAppFinish = key => ({ type: APP_LOADING_FINISH, key });
